<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-1"></a>
<p class="title">IMAGES OF WAR</p>
<p class="title1">KNIGHT’S CROSS WINNERS OF THE WAFFEN SS</p>
<p class="title11"><span class="bold">RARE PHOTOGRAPHS FROM WARTIME ARCHIVES</span></p>
<a id="VPS-2"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 001_Half_Title_page.vue?24fe41b6